import { useQuery } from "@tanstack/react-query";
import type { SalesInfoResponse } from "reedy-data/api";
import { useApi } from "hooks/useApi";

// Window-independent metadata from GET /books/sales/info; keyed by ISBNs only.
export function useSalesInfo(isbns: string[] | undefined) {
  const api = useApi();

  return useQuery<SalesInfoResponse | undefined>({
    queryKey: ["salesInfo", isbns?.join(",")] as const,
    queryFn: () => {
      if (!isbns?.length) {
        throw new Error("useSalesInfo: isbns are required when enabled");
      }
      return api.books.getSalesInfo({ isbns });
    },
    enabled: Boolean(isbns?.length),
    staleTime: 5 * 60 * 1000,
  });
}
